var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreateMessageTemplatePlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 76,
  height: 64,
  style: {
    background: "#14202c"
  },
  viewBox: "0 0 76 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 1,
  x: 17.5,
  y: 36.5,
  stroke: "#69728B",
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 1,
  x: 17.5,
  y: 25.5,
  stroke: "#69728B",
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 1,
  x: 17.5,
  y: 14.5,
  stroke: "#69728B",
  rx: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 51,
  r: 10,
  stroke: "#69728B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#69728B",
  d: "M67 50h-3v-3a1 1 0 0 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 0 0 0-2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#69728B",
  d: "M63 59.92c-4.96 0-9-4.04-9-9 0-.72.08-1.42.24-2.09.17-.7.42-1.37.75-2A8.99 8.99 0 0 1 63 41.92c1.85 0 3.57.56 5 1.52.69.46 1.31 1.01 1.84 1.64A8.9 8.9 0 0 1 72 50.92c0 4.96-4.03 9-9 9M15.17 46.83c-.53 0-1.03.21-1.41.58L4 57.05V9c0-1.65 1.35-3 3.01-3H65c1.66 0 3 1.35 3 3v32.12c-1.5-.77-3.2-1.2-5-1.2-4.63 0-8.59 2.86-10.21 6.91zM70 42.43V9c0-2.76-2.24-5-5-5H7.01C4.24 4 2 6.24 2 9v52.83l13.17-13H52.2c-.13.68-.2 1.38-.2 2.09 0 6.07 4.93 11 11 11 6.08 0 11-4.93 11-11 0-3.42-1.56-6.47-4-8.49"
}))));
export default SvgCreateMessageTemplatePlaceholder;